import React from "react";
import { useParams, useNavigate } from "react-router";
import { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { usePostEvent } from "../../hooks/usePostEvent";
import EventInfo from "../../components/EventInfo";

function EventDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const data = JSON.parse(localStorage.getItem("eventsData"));
  const user = localStorage.getItem("user") || null;
  const { logEvent } = usePostEvent(user);

  const event = data?.find((e) => e.eventID.toString() === id);
  const clubID = event.siteInfo.siteID.substr(0, 3);
  useEffect(() => {
    if (!clubID) return;
    logEvent(49, clubID);
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [clubID]);

  //console.log("🚀 ~ EventDetails ~ event:", event);

  if (!event)
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="h6">Event not found.</Typography>
        <Button sx={{ mt: 2 }} onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Box>
    );

  return <EventInfo event={event} />;
}

export default EventDetails;
